import type { CustomTooltipProps } from "ag-grid-react";

// Reusable AG Grid tooltip styled like the MUI <Tooltip> (dark rounded chip),
// so grid tooltips match the rest of the app instead of the plain AG Grid default.
// Usage: register on a grid and point the column(s) at it, e.g.
//   <AgGridReact components={{ agGridTooltip: AgGridTooltip }} ... />
//   colDef / defaultColDef: { tooltipComponent: "agGridTooltip", tooltipValueGetter }
export const AgGridTooltip = ({ value }: CustomTooltipProps) => {
	if (value === null || value === undefined || value === "") return null;

	return (
		<div
			style={{
				backgroundColor: "rgba(97, 97, 97, 0.92)",
				color: "#fff",
				padding: "4px 8px",
				borderRadius: 4,
				fontSize: "0.6875rem",
				fontWeight: 500,
				lineHeight: 1.4,
				maxWidth: 300,
				fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
				boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
			}}
		>
			{value}
		</div>
	);
};
